import { render, staticRenderFns } from "./TargetDetails.vue?vue&type=template&id=0aa486b8"
import script from "./TargetDetails.vue?vue&type=script&lang=js"
export * from "./TargetDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports